import "./report.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useState } from "react";
import axios from "axios";
import {
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  CircularProgress,
  Select,
  MenuItem,
} from "@mui/material";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import "nepali-datepicker-reactjs/dist/index.css";
import { useSelector } from "react-redux";

const PopulationReport = ({ inputs, title }) => {
  const userIdRedux = useSelector((state) => state.user.userId);
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const [peopleData, setPeopleData] = useState("All");
  const [errors, setErrors] = useState({});
  const [backEndError, setBackEndError] = useState("");
  const [loading, setLoading] = useState(false); // Loading state

  const validateForm = () => {
    const errors = {};

    if (!userIdRedux) errors.backEndError = "User ID is NULL. Please re-login.";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleGenerateReport = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true); // Start loading

    try {
      const response = await axios.get(
        `${BASE_URL}/api/report/generatePopulationReport/${userIdRedux}/${peopleData}`,
        { responseType: "blob" } // Handle binary response
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      // Create an anchor element and trigger the download
      const a = document.createElement("a");
      a.href = url;
      a.download = "Population_Report.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      if (response.status === 201) {
        setBackEndError(<font color="green">Success Generating Report</font>);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "There is no data to generate the report.";
      setBackEndError(<span style={{ color: "red" }}>{errorMessage}</span>);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div className="newUser">
      <Sidebar />
      <div className="newUserContainer">
        <Navbar />
        <div className="top">
          <h1>Population Report</h1>
        </div>
        <div className="bottom">
          <div style={{ display: "flex", gap: "16px" }}>
            <div style={{ flex: 4 }}>
              <FormControl
                style={{ flex: 4 }}
                margin="normal"
                error={Boolean(errors.peopleData)}
              >
                <InputLabel>Status</InputLabel>
                <Select
                  name="peopleData"
                  value={peopleData}
                  onChange={(e) => setPeopleData(e.target.value)}
                  required
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Live">Live</MenuItem>
                  <MenuItem value="Death">Death</MenuItem>
                </Select>
              </FormControl>
            </div>
            <label style={{ visibility: "hidden", flex: 6 }}></label>
          </div>

          {/* Button placed on a new line and made bigger */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              onClick={handleGenerateReport}
              variant="contained"
              color="primary"
              style={{
                borderRadius: "15px",
                width: "100%", // Takes full width
                fontSize: "18px", // Larger font size
                padding: "12px", // Larger padding
              }}
              disabled={loading} // Disable button while loading
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Generate Report"
              )}
            </Button>
          </div>

          <span className="error-message">{backEndError}</span>
        </div>
      </div>
    </div>
  );
};

export default PopulationReport;
